import "./App.css";
import Pecuscan from "./PecuScan/Pecuscan";
import "bootstrap/dist/css/bootstrap.min.css";
import PublicLedger from "./PecuScan/publicLedger";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import AddTransaction from "./PecuScan/AddTransaction/Addtransaction";
import BlockId from "./PecuScan/BlockId/block"
import TransactionId from "./PecuScan/TransactionId/transaction"
import AllBlock from "./PecuScan/AllBlock/allblock";
import TransactionTX from "./PecuScan/TransactionId/tx";
import RpcExplorer from "./PecuScan/RpcExplorer/RpcExplorer";
import EscrowId from "./PecuScan/EscrowId/escrow";



function App() {
  return (
    <>
      {/* <Pecuscan /> */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Pecuscan />} />
          <Route path="/allBlock" element={<AllBlock />} />
          <Route path="/addtransaction" element={<AddTransaction />} />
          <Route path="/block/:id" element={<BlockId />} />
          <Route path="/transaction/:id" element={<TransactionId />} />
          <Route path="/tx/:hash" element={<TransactionTX />} />
          <Route path="/rpc" element={<RpcExplorer />} />
          <Route path="/escrow/:pubKey" element={<EscrowId />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
